"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _Checkbox = _interopRequireDefault(require("./Checkbox"));

var _hooks = require("../../hooks");

var CheckboxGroup = function CheckboxGroup(_ref) {
  var options = _ref.options,
      headerCheckbox = _ref.headerCheckbox,
      children = _ref.children,
      className = _ref.className,
      onChange = _ref.onChange;

  var _useCheckAll = (0, _hooks.useCheckAll)(options, onChange),
      indeterminate = _useCheckAll.indeterminate,
      checkAll = _useCheckAll.checkAll,
      checkedList = _useCheckAll.checkedList,
      handleCheckAllChange = _useCheckAll.handleCheckAllChange,
      handleChange = _useCheckAll.handleChange;

  var SelectAllCheckbox = headerCheckbox ? (0, _jsxRuntime.jsx)(_Checkbox["default"], {
    id: headerCheckbox.id,
    indeterminate: indeterminate,
    onChange: handleCheckAllChange,
    checked: checkAll,
    css: headerCheckbox.css,
    children: checkAll ? headerCheckbox.unSelectTitle : headerCheckbox.title
  }) : null;
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [SelectAllCheckbox, children, options.map(function (_ref2) {
      var key = _ref2.key,
          label = _ref2.label,
          value = _ref2.value,
          id = _ref2.id;
      return (0, _jsxRuntime.jsx)(_Checkbox["default"], {
        id: id,
        onChange: handleChange,
        checked: checkedList.some(function (item) {
          return item.id === id;
        }),
        value: value,
        className: (0, _clsx["default"])('grui mr-12', className),
        children: label
      }, key || id);
    })]
  });
};

CheckboxGroup.propTypes = {
  /**
   * All options
   */
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]).isRequired,
    key: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    label: _propTypes.string.isRequired,
    value: _propTypes.string.isRequired,
    checked: _propTypes.bool
  })).isRequired,
  children: _propTypes.node,

  /**
   * Select all checkbox's config
   */
  headerCheckbox: (0, _propTypes.shape)({
    id: _propTypes.string,
    title: _propTypes.string,
    unSelectTitle: _propTypes.string
  }),

  /**
   * For checkboxes of options
   */
  className: _propTypes.string,

  /**
   * The callback function that is triggered when the state changes</br>
   * return checked list
   */
  onChange: _propTypes.func
};
CheckboxGroup.defaultProps = {
  headerCheckbox: undefined,
  className: undefined,
  children: undefined,
  onChange: function onChange() {}
};
var _default = CheckboxGroup;
exports["default"] = _default;
//# sourceMappingURL=CheckboxGroup.js.map